// src/components/Logo.jsx
import React from "react";

const Logo = ({ width = 96, height = 96 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 180 180"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="glow" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#00e0cc" />
        <stop offset="100%" stopColor="#08101c" />
      </radialGradient>

      <linearGradient id="neon" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#00ffe5" />
        <stop offset="100%" stopColor="#6f00ff" />
      </linearGradient>

      <filter id="green-glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="6" result="blur" />
        <feFlood floodColor="#009e94" floodOpacity="0.5" result="color" />
        <feComposite in="color" in2="blur" operator="in" result="glow" />
        <feMerge>
          <feMergeNode in="glow" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>

      <style>{`
        .fade-shapes {
          opacity: 0;
          transform-box: fill-box;
          transform-origin: center;
          transform: scale(0.95);
          animation: fadeInShapes 0.9s ease-out forwards;
        }
        @keyframes fadeInShapes {
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
        .fade-text {
          opacity: 0;
          transform-box: fill-box;
          transform-origin: center;
          transform: scale(0.95);
          animation: fadeInText 0.9s ease-out forwards;
          animation-delay: 0.9s;
        }
        @keyframes fadeInText {
          to {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>
    </defs>

    {/* Capa de fondo circular con degradado radial */}
    <rect width="180" height="180" rx="24" fill="url(#glow)" />

    {/* Formas internas con efecto glow */}
    <g className="fade-shapes">
      <circle
        cx="90"
        cy="90"
        r="62"
        fill="none"
        stroke="#009e94"
        strokeWidth="4"
        filter="url(#green-glow)"
      />
      <circle
        cx="90"
        cy="90"
        r="60"
        fill="#0c111f"
        stroke="#009e94"
        strokeWidth="4"
      />
      <path
        d="M60 90c0-16 13-30 30-30s30 14 30 30-13 30-30 30-30-14-30-30z"
        fill="#009e94"
        opacity="0.1"
      />
    </g>

    {/* Texto principal con degradado lineal */}
    <g className="fade-text">
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="28"
        fontFamily="'Orbitron', sans-serif"
        fill="url(#neon)"
        letterSpacing="2"
      >
        AIVEO
      </text>
      <text
        x="50%"
        y="65%"
        textAnchor="middle"
        fontSize="10"
        fontFamily="'Orbitron', sans-serif"
        fill="url(#neon)"
        letterSpacing="1"
      >
        AI CINEMA
      </text>
    </g>
  </svg>
);

export default Logo;